import { tss } from 'tss-react/mui';

const useStyles = tss
  .withParams<{
    isLayoutMobile: boolean;
  }>()
  .create(({ theme, isLayoutMobile }) => ({
    assetAddEditDialogIconButtonCancel: {
      height: '2rem',
      position: 'absolute',
      right: 8,
      top: 8,
      width: '2rem'
    },
    assetHalfWidthField: {
      width: isLayoutMobile ? '100%' : '48%'
    },
    complianceTagsContainer: {
      display: 'flex',
      gap: theme.spacing(1),
      maxHeight: '40px',
      flexWrap: 'nowrap',
      overflow: 'hidden',
      '& .MuiChip-root': {
        maxWidth: '120px', // Limit individual chip width
        '& .MuiChip-label': {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        }
      }
    },
    formFieldsContainer: {
      flexWrap: 'wrap',
      marginBottom: theme.spacing(3),
      marginTop: theme.spacing(3),
      gap: theme.spacing(3),
      alignItems: 'flex-start',
      alignContent: 'flex-start'
    }
  }));

export default useStyles;
